import axios from "axios";
import Alert from "components/ui/Alert";

const url = process.env.REACT_APP_API;
const API_KEY = process.env.REACT_APP_API_KEY;

export const api = axios.create({
  baseURL: url,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-API-KEY": API_KEY,
  },
  withCredentials: true,
});

export async function catchErrorHandler(error, funcName, isAlert = true) {
  const { status, data } = error.response;
  console.log(`${status} ${JSON.stringify(data?.message || data)} ${funcName}`);

  if (isAlert) {
    const errorConfirm = {
      // signUp
      confirmPhoneNumber: "올바른 휴대폰 번호를 입력해주세요",
      // setting
      removeAccount: "오류가 발생하였습니다<br/>잠시 후 다시 시도해 주십시오",
    };
    Alert(
      errorConfirm[funcName] ||
        data?.message ||
        "오류가 발생하였습니다<br/>잠시 후 다시 시도해 주십시오"
    );
  }

  throw "";
}

export function removeLocalStorage() {
  window.localStorage.removeItem("accessToken");
  window.localStorage.removeItem("seqManagerMobile");
  window.localStorage.removeItem("seqManagerMobileDevice");
  return;
}

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

api.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    console.log(error.response);
    const { data, config: originalRequest } = error.response;
    console.log("data:", data);

    // A00003 : Authorization 헤더가 존재하지 않습니다.
    if (data.errorCode === "A00003") {
      const accessToken = window.localStorage.getItem("accessToken");
      if (accessToken) {
        api.defaults.headers.common["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        return new Promise(function (resolve, reject) {
          resolve(api(originalRequest));
        });
      }
    }

    // A00002 : 토큰이 만료되었습니다.
    if (data.errorCode === "A00002") {
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            originalRequest.headers["Authorization"] = `Bearer ${token}`;
            return api(originalRequest);
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      const seqManagerMobileDevice = window.localStorage.getItem(
        "seqManagerMobileDevice"
      );
      return new Promise(function (resolve, reject) {
        api
          .post("/mobile/re-issuance-token", {
            seqManagerMobileDevice,
          })
          .then(({ data }) => {
            // 헤더에 전역으로 Authorization 적용
            api.defaults.headers.common["Authorization"] =
              `Bearer ${data.accessToken}`;
            // localstorage에 토큰 저장
            window.localStorage.setItem("accessToken", data.accessToken);
            processQueue(null, data.accessToken);
            originalRequest.headers["Authorization"] =
              `Bearer ${data.accessToken}`;
            resolve(api(originalRequest));
          })
          .catch((err) => {
            failedQueue = [];
            reject(err);
            removeLocalStorage();
            Alert("오류가 발생하였습니다.<br/>다시 로그인해주세요", {
              callback: () => {
                window.location = "/entrance/signin";
              },
            });
          })
          .finally(() => {
            isRefreshing = false;
          });
      });
    }

    return Promise.reject(error);
  }
);

export const delayResponse = (delay) => {
  return (data) => {
    return new Promise((resolve) => setTimeout(() => resolve(data), delay));
  };
};

export const isDuplicateRequest = (timestamp, milliseconds) => {
  if (!timestamp) return false;
  const isDuplicate = Date.now() - timestamp < (milliseconds || 500);
  return isDuplicate;
};
